import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

// eslint-disable-next-line import/prefer-default-export
export function convertHtmlToPdf(content: string): Promise<Blob> {
  return requestApi<Blob>({
    url: withForm('/pdf/convert'),
    method: 'POST',
    data: { content },
    responseType: 'blob',
    credentials: true,
  }).then((res) => res.data);
}
